import { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import qs from 'qs';
import { post } from '../utils/apiUtilities';
import $ from 'jquery';
import rr from '../../scripts/radresponder';
import toastr from 'toastr';

function SelectOption({ location }) {
    const queryString = qs.parse(location.search, { ignoreQueryPrefix: true });
    const returnUrl = queryString.ReturnUrl || queryString.returnUrl;
    const token = queryString.token;
    const username = queryString.username;

    const [option, setOption] = useState(null);
    const [isSending, setIsSending] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [mfaOptions, setMfaOptions] = useState([]);

    const send = async (e) => {

        e.preventDefault();
        setIsSending(true);

        try {
            const optionParts = option.split('|');
            const d = await post('account/sendmfacode', {
                identifier: token,
                mfaTypeId: optionParts[0],
                mfaOptionId: optionParts[1],
                returnUrl: returnUrl,
                username: username
            });

            window.location.href = d.redirect;
        }
        catch (err) {
            setIsSending(false);
            if (err && err.responseText) {
                setErrorMessage((err.status === 400 || err.status === 401) ? err.responseText : 'An error occurred while logging in.');
            }

            throw (err);
        }
        finally {
            setIsSending(false);
        }
    }

    const activate = useCallback(async() => {
        try{
            const data = await $.get(rr.getApiAddress() + "account/mfaoptions/" + token)
            setMfaOptions(data.mfaOptions);
        }
        catch (err){
            toastr.error(rr.extractError(err, err, err));
        }
    }, [token]);

    useEffect(() => {
        (async() => {
            activate()
        })()
    }, [activate]);

    const Options = () => {
        return (<>
            <option value="" style={{ display: 'none' }}>Select a method...</option>
            {mfaOptions.map((o) => {
                let optionKey = o.mfA_Type_Id + "|" + o.mfA_Option_Id;
                return <option key={optionKey} value={optionKey}>{o.mfA_Type}: {o.mfA_Option_Display}</option>;
                }                
            )}
            </>);
    }

    return (
        <>
            <Helmet>
                <title>Sign In | CBRN Network</title>
            </Helmet>
            <div id="layout-shell" className="shell top100">
                <div className="main-content container" id="loginCont" tabIndex="-1">
                    <div className="row">
                        <main>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-md-offset-3 col-lg-offset-3">
                                <form autoComplete="off" className="form-horizontal signin-form" onSubmit={send}>
                                    {(!(errorMessage && errorMessage.length) ? '' : (
                                        <div className="alert alert-danger">
                                            <span>{errorMessage}</span>
                                        </div>
                                    ))}

                                    <div className="panel panel-default">
                                        <div className="panel-body">
                                            <div className="bottom10 bigger-120">{username}</div>

                                            <div className="form-group">
                                                <label className="col-xs-12 required-field-indicator">Select a method to receive an authentication code:</label>
                                                <div className="col-xs-12">
                                                    <select className="form-control select2-hidden-accessible" 
                                                        aria-hidden="true"
                                                        value={option}
                                                        onChange={(e) => {
                                                            setOption(e.target.value);
                                                        }}>
                                                        <Options />
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <div className="col-xs-12">
                                                    <button id="loginButtonExternalLoginProvider"
                                                        className="btn btn-success btn-lg btn-block"
                                                        name="button"
                                                        disabled={isSending || !option}
                                                        onClick={send}>
                                                        {isSending ? "Sending..." : "Send Code"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </>
    );
}

export default withRouter(SelectOption);
